import { render, staticRenderFns } from "./presell-explain.vue?vue&type=template&id=d24919ce&scoped=true&"
import script from "./presell-explain.vue?vue&type=script&lang=js&"
export * from "./presell-explain.vue?vue&type=script&lang=js&"
import style0 from "./presell-explain.vue?vue&type=style&index=0&id=d24919ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24919ce",
  null
  
)

export default component.exports